import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { i18n, t } = useTranslation();

  return (
    <div className="ardosz-control-group ardosz-language-toggle">
      <label htmlFor="language-select">{t('language')}</label>
      <select
        id="language-select"
        value={i18n.language}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
      >
        <option value="nl">Nederlands</option>
        <option value="en">English</option>
      </select>
    </div>
  );
}
